import BookingItem from '../booking-item/main'
import { bookedServiceEditEvents } from '../../../js/document/event-types'
import { registerWidget } from '../../../js/core/widget/widget-directory'
import { getSearchParamsFromUrl, buildUrlWithParams } from '../../../js/document/url'
import { removeUndefinedKeys } from '../../../js/helpers/object'
import { arrayifyObject } from '../../../js/helpers/arrayify-object'

const widgetApi = 'w-booked-service-navigation'

const widgetQueries = {
  button: `[data-${widgetApi}__button]`,
  buttonApi: 'c-btn'
}

const operationTypeEnum = {
  patch: 'Patch'
}

const islistedKey = (key) => (
  /^sid/i.test(key)
)

const EXCLUDE_URL_PARAMS = (params) => {
  return params
    ? Object.keys(params)
      .filter(key => !islistedKey(key))
      .reduce((obj, key) => ({
        ...obj,
        [key]: params[key]
      }), {})
    : {}
}

export default class BookedServiceNavigation extends BookingItem {
  /**
   *
   * @param {HTMLElement} element   - The HTML content
   */
  constructor (element) {
    super(element)
    this.element = element
    this.button = this.element.querySelector(widgetQueries.button)
    this.url = element.dataset.url
    this.saveUrl = element.dataset.saveUrl
    this._attachEvents()
  }

  _attachEvents () {
    if (this.button) {
      this.button[widgetQueries.buttonApi].events.on('clickButton', (ev) => { this._saveChangesRequested(ev) })
    }
  }

  /**
   * Returns the params from URL params, if there's any
   * - Get the relevant params from the URL
   *
   * @returns {Object}
   */
  getParamsFromURL () {
    if (!document.location.search) return {}
    const relevantUrlParams = EXCLUDE_URL_PARAMS(
      removeUndefinedKeys(getSearchParamsFromUrl(document.location, { useUndefinedValue: true }))
    )

    if (!relevantUrlParams || Object.keys(relevantUrlParams).length === 0) return {}

    return relevantUrlParams
  }

  /**
 * Update Browser's url with all the params excepting the hidden ones
 * - Should happen after each update
 * - The main purpose is to enable copy/share the URL
 *
 * @returns Url without excluded params
 */
  updateBrowserUrl () {
    this.currentUrlParams = { ...this.getParamsFromURL() }

    window.history.replaceState(
      '',
      '',
      buildUrlWithParams(
        document.URL.split('?')[0],
        arrayifyObject({
          ...this.currentUrlParams,
          ...this.currentParams
        })
      ))
    return document.URL
  }

  _saveChangesRequested (ev) {
    const eventData = {
      url: this.updateBrowserUrl(),
      saveUrl: this.saveUrl,
      method: operationTypeEnum.patch,
      elementType: ev.type || ''
    }

    this.events.emit(bookedServiceEditEvents.SAVE_CHANGES_PROCESS_STARTED, eventData)
  }
}

registerWidget(BookedServiceNavigation, widgetApi)
